import { render, staticRenderFns } from "./AttributesStatistics.vue?vue&type=template&id=50bdd27e&"
import script from "../../models/analysis/attributes-statistics.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/attributes-statistics.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports